import { Typography } from "@mui/material";
import React from "react";

import { IIntroGreetingProps } from "./IIntroGreetingProps";

/** Displays a greeting for the PA to read. */
const IntroGreeting: React.FC<IIntroGreetingProps> = ({ userFirstName, customerFirstName, outbound }) => {
  const language = outbound
    ? `Hi, is this ${customerFirstName}?`
    : `Thank you for calling Sono Bello, this is ${userFirstName}. Who do I have the pleasure of speaking with?`;

  return <Typography variant="body2">{language}</Typography>;
};

export default IntroGreeting;
